<template>
  <div>
    <!-- head头部导航栏 -->
    <el-header class="headder">

      <!-- 左边的盒子 -->
      <div class="header-left">
        <!-- logo和title -->
        <a class="header_logo" href="javascript:;">
          <span class="logo">
            <img src="../../assets/image/Logo (3).png" alt="">
          </span>
          <span>
            贝游特教育
          </span>
        </a>
        <!-- 首页和常见问题 -->
        <div class="header_nav">
          <a href="javascript:;" class="active-color">首页</a>
          <a href="javascript:;" @click="goQuestion" class="header-a-color">常见问题</a>
        </div>
      </div>
      <!-- 右边的盒子未登录 -->
      <!-- <div class="header-right">
        <span>登录</span>
      </div> -->
      <!-- 右边的盒子已登录 -->

    </el-header>
    <!-- banner图片区域 -->
    <div class="banner" style="background-color: rgb(243, 251, 255);">
      <div class="banner--default"></div>
    </div>
    <!-- main 版心区域 -->
    <div class="layerContainer">
      <!-- 中间版心 -->
      <div class="main">
        <!-- 游戏相关模块 -->
        <div class="com_problem">
          <div class="classify_body">
            <!-- 游戏相关 -->
            <div class="title_tab">
              <ul>
                <li>游戏相关</li>
                <div class="is-active"></div>
              </ul>
            </div>
            <!-- 下面的具体游戏消息盒子 -->
            <div class="classify_content">
              <div class="pc_home_pro_list">
                <ul>
                  <li class="item" @click="goQuestion1">
                    <a href="javascript:;">
                      <span class="item_font">账号注册无法进入游戏</span>
                    </a>
                  </li>
                  <li class="item" @click="goQuestion2">
                    <a href="javascript:;">
                      <span class="item_font">官方联系方式</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <!-- 留言导航栏 -->
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="最新" name="first">
            <el-row :gutter="20" class="recommend-box">
              <!-- 左边的盒子 头像 -->
              <!-- <el-col :span="3">
                <div class="grid-content bg-purple">
                  <a href="javascript:;" class="user-avatar">
                    <img src="../../assets/image/Logo.png" alt="">
                  </a>
                </div>
              </el-col> -->
              <!-- 右边的盒子 发言和评论 -->
              <el-col :span="24">
                <div>
                  <!-- 时间 用户名 -->
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <div class="grid-content bg-purple-dark">
                        <el-row>
                          <!-- 用户名 -->
                          <el-col :span="2">
                            <div class="grid-content bg-purple">
                              <a href="javascript:;" class="user-name">贝游特</a>
                            </div>
                          </el-col>
                          <!-- 官方 -->
                          <el-col :span="2">
                            <div class="grid-content bg-purple">
                              <div class="tag__admin">官方</div>
                            </div>
                          </el-col>
                          <!-- 时间 -->
                          <el-col :span="14">
                            <div class="grid-content bg-purple-light">
                              <div class="release-time">2023年2月8日 12:00</div>
                            </div>
                          </el-col>
                          <!-- 公告和置顶 -->
                          <el-col :span="4">
                            <div class="grid-content bg-purple">
                              <div class="button-box">
                                <el-button type="primary" size="mini">公告</el-button>
                                <el-button size="mini">置顶</el-button>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 发言 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content bg-purple-dark speak">
                        大家好，我们是荒野坦克大战的开发者团队，如果您有任何疑问与支持，可以在这里进行留言发布或联系QQ群：599261488，我们将在收到后尽快作出回复并进行解答。谢谢各位玩家的支持
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 点赞评论 和隐藏的详情举报 -->
                  <el-row class="details-box">
                    <!-- 左边的空白 -->
                    <el-col :span="12" class="blank-box"></el-col>
                    <!-- 右边的点赞评论 和隐藏的详情举报 -->
                    <el-col :span="12" class="right-icon-box">
                      <el-row>
                        <!-- 左边鼠标经过才出现的详情和举报 -->
                        <el-col :span="12" class="hide-details">
                          <el-row>
                            <el-col :span="8">
                              <i class="el-icon-warning-outline"></i>
                            </el-col>
                            <el-col :span="8">
                              <el-tooltip effect="dark" content="微信发帖才能被赞赏" placement="bottom">
                                <i class="el-icon-present"><i class="icon-text">赞赏</i></i>
                              </el-tooltip>
                            </el-col>
                            <el-col :span="8">
                              <i class="el-icon-tickets"><i class="icon-text">详情</i></i>
                            </el-col>
                          </el-row>
                        </el-col>
                        <!-- 右边的点赞 -->
                        <el-col :span="12">
                          <el-row>
                            <el-col :span="9">
                              <i class="el-icon-thumb"><i class="icon-text">点赞</i></i>
                            </el-col>
                            <el-col :span="15">
                              <i class="el-icon-chat-square"><i class="icon-text">已关评论</i></i>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <!-- 用户留言的名字和内容 -->
            <div v-for="item in speakList" :key="item.index" class="user-matter-box">
              <p class="user_name">{{item.Mobile}}</p>
              <p class="user-matter">{{item.WenTi}}</p>
              <!-- 点赞评论 和隐藏的详情举报 -->
              <el-row class="details-box">
                <!-- 左边的空白 -->
                <el-col :span="12" class="blank-box"></el-col>
                <!-- 右边的点赞评论 和隐藏的详情举报 -->
                <el-col :span="12" class="right-icon-box">
                  <el-row>
                    <!-- 左边鼠标经过才出现的详情和举报 -->
                    <el-col :span="12" class="hide-details">
                      <el-row>
                        <el-col :span="8">
                          <i class="el-icon-warning-outline"></i>
                        </el-col>
                        <el-col :span="8">
                          <el-tooltip effect="dark" content="微信发帖才能被赞赏" placement="bottom">
                            <i class="el-icon-present"><i class="icon-text">赞赏</i></i>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="8">
                          <i class="el-icon-tickets"><i class="icon-text">详情</i></i>
                        </el-col>
                      </el-row>
                    </el-col>
                    <!-- 右边的点赞 -->
                    <el-col :span="12">
                      <el-row>
                        <el-col :span="9">
                          <i class="el-icon-thumb"><i class="icon-text">点赞</i></i>
                        </el-col>
                        <el-col :span="15">
                          <i class="el-icon-chat-square"><i class="icon-text">已关评论</i></i>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

          </el-tab-pane>
          <!-- <el-tab-pane label="最新" name="second">最新</el-tab-pane>
          <el-tab-pane label="好问题" name="third">好问题</el-tab-pane> -->
        </el-tabs>
      
      
        <div class="beian">
          <a href="https://beian.miit.gov.cn">蜀ICP备18026143号</a>
          <div class="gongsi">成都贝游特教育科技有限公司</div>
        </div>
      </div>
      <!-- 右侧广告 -->
      <div class="side">
        <!-- 赞同 和我要发言 -->
        <div class="side_info">
          <!-- 赞同 回答 提问 -->
          <div class="side_info_mess">
            <div class="item">
              <a href="javascript:;" class="author_link">
                <span>0</span>
                <span>被赞同</span>
              </a>
            </div>
            <div class="item">
              <a href="javascript:;" class="author_link">
                <span>0</span>
                <span>回答</span>
              </a>
            </div>
            <div class="item">
              <a href="javascript:;" class="author_link">
                <span>{{quiz}}</span>
                <span>提问</span>
              </a>
            </div>
          </div>
          <!-- 我要发言 -->
          <button class="product-home__post-btn" @click="speakBtn">我要发言</button>
        </div>
        <!-- 团队博客 -->
        <div class="team_blog">
          <div class="team_blog__topic">团队博客</div>
          <div class="team_blog__story">
            <a href="javascript:;">
              <img src="../../assets/image/our_story.jpg" alt="">
            </a>
          </div>
        </div>
        <!-- 广告 -->
        <!-- <div class="promotionbit" v-if="activeAdvertisy">
          <a href="javascript:;">
            <img src="https://txc.gtimg.com/static/txc.5463165e.png" alt="">
          </a>
          <span class="promotionbit__btn">
            <i @click="advertisyBtn">{{advertising}}</i>
          </span>
        </div> -->
      </div>
    </div>
    

    <!-- 发言模态框 -->
    <el-dialog title="发言" :visible.sync="speakDialog" width="30%">
      <el-form :model="speakForm" :rules="speakRules" ref="speakForm">
        <el-form-item prop="speakDesc">
          <el-input type="textarea" v-model="speakForm.speakDesc" placeholder="你的建议、反馈和想法会帮助跟多的人..."></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subSpeak">发布</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      advertising: "广告",
      activeName: "first",
      speakDialog: false,
      speakForm: {
        speakDesc: "",
      },
      speakRules: {
        speakDesc: [{ required: true, message: "请描述问题", trigger: "blur" }],
      },
      speakList: [],
      quiz: 0,
    };
  },
  mounted() {
    this.getSpeakList();
  },
  methods: {
    goQuestion() {
      this.$router.push("/Container/question");
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    goQuestion1() {
      this.$router.push({ path: "/Container/question", query: { id: "1-1" } });
    },
    goQuestion2() {
      this.$router.push({ path: "/Container/question", query: { id: "1-2" } });
    },
    // 我要发言按钮
    speakBtn() {
      const mobile = sessionStorage.mobile;
      if (mobile) {
        this.speakDialog = true;
      } else {
        this.$confirm("未登录的用户不能发言，点击确定前往登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
      }
    },
    // 提交发言
    subSpeak() {
      const speakDesc = this.speakForm.speakDesc;
      const mobile = sessionStorage.mobile;
      this.$refs.speakForm.validate((valid) => {
        if (valid) {
          this.$api
            .get("http://gm.test.ollq.com:8868/BaBaLiuLiu/client/setwenti", {
              params: {
                mobile: mobile,
                wenti: speakDesc,
              },
            })
            .then((res) => {
              console.log(res);
              this.$refs.speakForm.resetFields();
              this.speakDialog = false;
              this.getSpeakList();
            });
        }
      });
    },
    // 获取发言列表
    getSpeakList() {
      this.quiz = 0;
      this.$api
        .get("http://gm.test.ollq.com:8868/BaBaLiuLiu/client/getwenti")
        .then((res) => {
          console.log(res);
          this.speakList = res.data;
          this.speakList.forEach((e) => {
            const mobile = sessionStorage.mobile;
            if (mobile == e.Mobile) {
              this.quiz++;
            }
          });
          console.log(this.quiz);
        });
    },
  },
};
</script>

<style>
@import url("home.css");
</style>


// WEBPACK FOOTER //
// src/views/home/home.vue